import { graphql } from "@opensea/graphql"
import { CollectionSweepQuoteReceiptFragment } from "../../../../../components/CollectionSweepQuoteReceipt/CollectionSweepQuoteReceipt.fragment"

export const CollectionSweepReceiptFragment = graphql(
  `
    fragment CollectionSweepReceipt on CollectionSweepQuoteResponse {
      ...CollectionSweepQuoteReceipt
    }
  `,
  [CollectionSweepQuoteReceiptFragment],
)
